import {
  ArrowDownIcon,
  DocumentPlusIcon,
  PlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { useTranslation } from "react-i18next";

interface ActionButtonsProps {
  onAdd?: () => void;
  onImport?: () => void;
  onDelete?: () => void;
  onExport?: () => void;
  className?: string;
}



export const TableActionButtons: React.FC<ActionButtonsProps> = ({
  onAdd,
  onDelete,
  onImport,
  onExport,
  className = "",
}) => {
  const handlers = { onAdd, onDelete, onExport, onImport };
const {t} = useTranslation()
const baseBtnClasses =
  "mx-2 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center   focus:ring-4 focus:outline-none";

const buttons = [
  {
    key: "add",
    label: t('action_add'),
    onClickKey: "onAdd",
    bgColor: "bg-blue-600 hover:bg-blue-700 focus:ring-blue-600",
    icon: <PlusIcon className="h-4 w-4" aria-hidden="true" />,
  },
  {
    key: "import",
    label: t('action_import'),
    onClickKey: "onImport",
    bgColor: "bg-blue-800 hover:bg-blue-900 focus:ring-blue-800",
    icon: <DocumentPlusIcon className="h-4 w-4" aria-hidden="true" />,
  },
  {
    key: "delete",
    label: t('action_delete'),
    onClickKey: "onDelete",
    bgColor: "bg-red-600 hover:bg-red-700 focus:ring-red-500",
    icon: <XMarkIcon className="h-4 w-4" aria-hidden="true" />,
  },
  {
    key: "export",
    label: t('action_download'),
    onClickKey: "onExport",
    bgColor: "bg-gray-500 hover:bg-gray-500 focus:ring-gray-500",
    icon: <ArrowDownIcon className="h-4 w-4" aria-hidden="true" />,
  }, 
];
  return (
    <div className={`flex ${className}`}>
      {buttons.map(({ key, label, onClickKey, bgColor, icon }) =>
        handlers[onClickKey as keyof typeof handlers] ? (
          <button
            key={key}
            type="button"
            className={`${baseBtnClasses} ${bgColor} dark:focus:ring-opacity-55`}
            onClick={handlers[onClickKey as keyof typeof handlers]}
          >
            {icon}
            &nbsp;&nbsp;
            {label}
          </button>
        ) : null
      )}
    </div>
  );
};
